export function getPostAuthRoute(user, fallback = "/") {
  if (typeof fallback === "string" && fallback !== "/" && fallback.startsWith("/") && !fallback.startsWith("//")) {
    return fallback;
  }
  const role = String(user?.role || "").toLowerCase();

  if (role === "admin" || role === "host" || role === "manager") {
    return fallback && fallback.startsWith("/host") ? fallback : "/host/calendar";
  }

  return "/";
}

export function getAuthErrorMessage(error, fallbackMessage) {
  const response = error?.response?.data || {};
  const details = Array.isArray(response.details) ? response.details : [];
  const code = response.code;

  if (code === "validation_error" && details.length > 0) {
    if (details.includes("username")) {
      return "Kullanıcı adı veya e-posta en az 2 karakter olmalı.";
    }
    if (details.includes("password")) {
      return "Şifre en az 6 karakter olmalı.";
    }
    if (details.includes("remember")) {
      return "Beni hatırla alanı geçersiz.";
    }
    if (details.includes("identifier")) {
      return "Kullanıcı adı veya e-posta geçersiz.";
    }
    if (details.includes("token")) {
      return "Sıfırlama bağlantısı veya kodu geçersiz.";
    }
    if (details.includes("newPassword")) {
      return "Yeni şifre en az 6 karakter olmalı.";
    }
  }

  return response.error || fallbackMessage;
}
